import { forwardRef } from "react";
import { RefreshCw } from "lucide-react";

export const PromptCard = forwardRef(function PromptCard(
  {
    color = "#22C55E",
    eyebrow,
    title,
    subtitle,
    details,
    onRegenerate,
    loading,
    testId = "prompt-card",
    watermark,
    children,
  },
  ref
) {
  return (
    <div
      ref={ref}
      data-testid={testId}
      className="bg-white border-4 border-[#1a1a1a] rounded-3xl shadow-hard-lg p-6 sm:p-10 max-w-3xl mx-auto pop-in relative"
    >
      {watermark && (
        <div className="absolute top-3 right-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#737373] font-bold">
          {watermark}
        </div>
      )}
      {eyebrow && (
        <div
          className="inline-block font-mono text-xs uppercase tracking-[0.25em] font-bold border-4 border-[#1a1a1a] rounded-full px-4 py-1 mb-5"
          style={{ background: color }}
        >
          {eyebrow}
        </div>
      )}
      <h2 className="font-display font-black text-3xl sm:text-5xl leading-[1.05] tracking-tight mb-4">{title}</h2>
      {subtitle && (
        <p className="font-mono text-base sm:text-lg text-[#4a4a4a] leading-relaxed mb-6">{subtitle}</p>
      )}
      {details && details.length > 0 && (
        <ul className="space-y-2 mb-6">
          {details.map((d, i) => (
            <li
              key={i}
              className="font-mono text-sm sm:text-base flex items-start gap-3 text-[#1a1a1a]"
            >
              <span
                className="mt-1 w-3 h-3 rounded-full border-2 border-[#1a1a1a] shrink-0"
                style={{ background: color }}
              />
              {d}
            </li>
          ))}
        </ul>
      )}
      {children}
      {onRegenerate && (
        <button
          data-testid="regenerate-btn"
          data-exclude-from-image="true"
          onClick={onRegenerate}
          disabled={loading}
          className="press mt-2 inline-flex items-center gap-2 bg-[#1a1a1a] text-white border-4 border-[#1a1a1a] rounded-xl px-6 py-3 font-mono text-sm uppercase tracking-wider font-bold shadow-hard-sm disabled:opacity-60"
        >
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} strokeWidth={3} />
          {loading ? "Generando..." : "Otra idea"}
        </button>
      )}
    </div>
  );
});

export default PromptCard;
